export const localStorageSupported = () => {
	return typeof localStorage !== 'undefined';
};

export const getUrlParam = (name: string): string | null => {
	if (typeof window === 'undefined') {
		return '';
	}

	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(name);
};

export const currentUrlParamsWith = (name: string, value: string) => {
	if (typeof window === 'undefined') {
		return '';
	}

	const urlParams = new URLSearchParams(window.location.search);
	urlParams.set(name, value);
	return `?${urlParams.toString()}`;
};

export const currentUrlParamsWithout = (name: string | string[]) => {
	if (typeof window === 'undefined') {
		return '';
	}

	const urlParams = new URLSearchParams(window.location.search);
	if (!Array.isArray(name)) {
		name = [name];
	}
	name.forEach((n) => urlParams.delete(n));

	return `?${urlParams.toString()}`;
};
